import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconLlmArrowLeft = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg enableBackground="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="icon-llm-arrow-left" width="1em" height="1em" data-icon="icon-llm-arrow-left" aria-hidden="true" {...props} ref={ref}><path clipRule="evenodd" d="m2.6 11.2 8.4-8.4-1-1-9.8 9.8c-.3.3-.3.7 0 1.1l9.8 9.8 1-1.1-8.4-8.5h21.4v-1.5h-21.4z" fill="currentColor" fillRule="evenodd"/></svg>);
});

IconLlmArrowLeft.displayName = 'IconLlmArrowLeft';
